<script setup lang="ts"></script>
<template>
  <footer>
    <div class="container">
      <h1>Footer</h1>
      <div class="footer-content">
        <a href="https://twitter.com/serkaann06" class="twitter">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 309.142 309.142"
            style="enable-background: new 0 0 309.142 309.142"
            xml:space="preserve"
          >
            <g>
              <path
                style="fill: #61b4e4"
                d="M154.571,0C69.662,0,0.83,68.832,0.83,153.741c0,38.283,13.997,73.295,37.147,100.207
		c-6.953,19.986-19.807,37.21-36.479,49.581c10.592,3.619,21.938,5.613,33.757,5.613c20.214,0,39.082-5.751,55.067-15.698
		c19.551,9.006,41.311,14.038,64.249,14.038c84.909,0,153.741-68.832,153.741-153.742C308.313,68.832,239.48,0,154.571,0z"
              />
              <g>
                <g>
                  <path
                    style="fill: #ffffff"
                    d="M240.278,88.33c-6.817,3.988-14.372,6.875-22.411,8.436c-6.424-6.749-15.593-10.969-25.744-10.969
				c-19.478,0-35.271,15.546-35.271,34.73c0,2.715,0.313,5.358,0.906,7.903c-29.316-1.449-55.31-15.27-72.709-36.278
				c-3.032,5.123-4.78,11.087-4.78,17.458c0,12.045,6.238,22.672,15.698,28.905c-5.774-0.191-11.22-1.747-15.978-4.345
				c0,0.147,0,0.29,0,0.437c0,16.819,12.163,30.855,28.305,34.051c-2.967,0.795-6.082,1.219-9.303,1.219
				c-2.272,0-4.479-0.222-6.639-0.625c4.499,13.79,17.517,23.836,32.955,24.117c-12.078,9.307-27.28,14.864-43.818,14.864
				c-2.854,0-5.654-0.164-8.418-0.486c15.62,9.848,34.168,15.599,54.082,15.599c64.891,0,100.364-52.907,100.364-98.796
				c0-1.505-0.021-3.008-0.091-4.497c6.885-4.889,12.872-11.009,17.6-17.978c-6.327,2.766-13.121,4.624-20.263,5.463
				C232.052,103.254,237.637,96.445,240.278,88.33z"
                  />
                </g>
              </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </a>
        <a href="#" class="linkedin">
          <svg
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 473.931 473.931"
            style="enable-background: new 0 0 473.931 473.931"
            xml:space="preserve"
          >
            <circle
              style="fill: #4a86c5"
              cx="236.966"
              cy="236.966"
              r="236.966"
            />
            <path
              style="fill: #3d80b2"
              d="M404.518,69.383c92.541,92.549,92.549,242.59,0,335.138c-92.541,92.541-242.593,92.541-335.134,0
	L404.518,69.383z"
            />
            <path
              style="fill: #4a86c5"
              d="M462.646,309.275c0.868-2.713,1.658-5.456,2.432-8.206
	C464.307,303.823,463.496,306.562,462.646,309.275z"
            />
            <g>
              <polygon
                style="fill: #377ca5"
                points="465.097,301.017 465.097,301.017 465.082,301.07 	"
              />
              <path
                style="fill: #377ca5"
                d="M465.097,301.017L336.721,172.641l-29.204,29.204l-20.303-20.303l-16.946,16.946L171.032,99.25
		l-6.155-2.346l-38.08,38.08l45.968,45.964l-44.998,44.995l43.943,43.943l-48.048,48.052L276.475,470.59
		c87.984-14.78,159.5-77.993,186.175-161.311c0.849-2.716,1.658-5.452,2.432-8.206C465.082,301.055,465.09,301.032,465.097,301.017z
		"
              />
            </g>
            <path
              style="fill: #ffffff"
              d="M358.565,230.459v87.883h-50.944v-81.997c0-20.595-7.375-34.656-25.811-34.656
	c-14.084,0-22.458,9.474-26.147,18.634c-1.343,3.278-1.688,7.835-1.688,12.423v85.593H203.02c0,0,0.681-138.875,0-153.259h50.952
	V186.8c-0.094,0.161-0.236,0.34-0.329,0.498h0.329V186.8c6.769-10.425,18.862-25.324,45.923-25.324
	C333.432,161.479,358.565,183.384,358.565,230.459z M149.7,91.198c-17.429,0-28.838,11.439-28.838,26.473
	c0,14.716,11.072,26.495,28.164,26.495h0.344c17.766,0,28.823-11.779,28.823-26.495C177.857,102.636,167.137,91.198,149.7,91.198zM123.886,318.341h50.944V165.083h-50.944V318.341z"
            />
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
          </svg>
        </a>
      </div>
    </div>
  </footer>
</template>
<style scoped lang="scss">
footer {
  margin-top: 10px;
  min-height: 100px;
  background: #f1f1f1;
  padding: 10px;
  box-sizing: border-box;
  h1 {
    text-align: center;
    margin-top: 10px;
  }
  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    a {
      margin-right: 5px;
      svg {
        width: 30px;
        height: 30px;
      }
    }
  }
}
</style>
